export const emailSenderNameIsValid = (name: string) => name.trim().length > 0;
